import { Routes } from "@angular/router";

export const FinaPay_ROUTES: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('./pages/pages.routes').then((m) => m.routes),
    },
];